import institutionAPI from 'services/institutionAPI'
import { UnifiedPersonFilters } from 'CitizenProfile/types'

type Params = {
  filters: UnifiedPersonFilters
}

export default async function readUnifiedPeopleOnCustomForm({ filters }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/citizen-portal/service/unified-people',
    data: filters,
  })

  return response
}
